import React, { useState, useEffect } from 'react';

const AdminPage = () => {
  const [organization, setOrganization] = useState('');
  const [user, setUser] = useState('');

  // Cargar datos desde localStorage al montar el componente
  useEffect(() => {
    const savedOrganization = localStorage.getItem('organization');
    const savedUser = localStorage.getItem('user');
    if (savedOrganization) setOrganization(savedOrganization);
    if (savedUser) setUser(savedUser);
  }, []);

  const handleSave = () => {
    localStorage.setItem('organization', organization);
    localStorage.setItem('user', user);
    console.log('Datos guardados en Local Storage');
  };

  return (
    <div>
      <h1>Bienvenido, {user || 'Usuario'}</h1>

      <div className="form-group">
        <label htmlFor="organization">Nombre de la Organización o Equipo:</label>
        <input
          type="text"
          id="organization"
          value={organization}
          onChange={(e) => setOrganization(e.target.value)}
          className="form-control"
          placeholder="Ingresa el nombre de la organización o equipo"
        />
      </div>

      <div className="form-group">
        <label htmlFor="user">Nombre de Usuario:</label>
        <input
          type="text"
          id="user"
          value={user}
          onChange={(e) => setUser(e.target.value)}
          className="form-control"
          placeholder="Ingresa el nombre de usuario"
        />
      </div>

      <button onClick={handleSave} className="btn btn-primary mt-3">
        Guardar
      </button>
    </div>
  );
};

export default AdminPage;
